// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lx-0";
export var fileList = "_lx-2";
export var removeFileButton = "_lx-1";